module.exports = __webpack_public_path__ + "img/arrow-right.c7f7a937.svg";